module.exports = __webpack_public_path__ + "img/Student.e586e058.png";